module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/economics-hover.c373f852.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/economics-hover.png
// module id = 3437
// module chunks = 11